import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import VeranstaltungenSection from '../components/VeranstaltungenSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const HomePage = () => {
  useEffect(() => {
    if (window.location.hash) {
      setTimeout(() => {
        const element = document.querySelector(window.location.hash);
        if (element) {
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - 100;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 300);
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  const scrollToContact = (e) => {
    e.preventDefault();
    const element = document.querySelector('#contact');

    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 100;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <>
      <Navbar />
      <HeroSection />
      <AboutSection />
      <VeranstaltungenSection />

      {/*
      <VorteileSection />
      <VerbindungSection />
      <HausSection />
      */}

      {/* Kontaktbereich */}
      <section>
        <ContactSection />
      </section>

      <Footer />

      {/* Floating Contact Button */}
      <button
        onClick={scrollToContact}
        className="floating-contact-button"
      >
        Kontakt
      </button>
    </>
  );
};

export default HomePage;
